<template>
  <div class="checkout-page">
    <div class="container">
      <!-- 頁面標題 -->
      <header class="header">
        <h1>購物車</h1>
      </header>

      <!-- 步驟指示器 -->
      <div class="steps">
        <div class="step active">
          <div class="step-number">1</div>
          <span>確認商品</span>
        </div>
        <div class="step">
          <div class="step-number">2</div>
          <span>填寫資料</span>
        </div>
        <div class="step">
          <div class="step-number">3</div>
          <span>訂單成立</span>
        </div>
      </div>

      <!-- 主要內容區 -->
      <div class="checkout-grid">
        <!-- 左側：購物車商品列表 -->
        <div class="main-content">
          <!-- 空購物車狀態 -->
          <div v-if="cartItems.length === 0" class="card empty-cart">
            <div class="empty-cart-content">
              <i class="fas fa-shopping-cart"></i>
              <h3>購物車是空的</h3>
              <p>快去選購喜歡的商品吧！</p>
              <button class="btn btn-primary" @click="goToProducts">
                前往選購
              </button>
            </div>
          </div>

          <!-- 購物車商品 -->
          <div v-else class="card">
            <h2>購物車商品</h2>
            <div class="cart-items">
              <div v-for="item in cartItems" :key="item.id" class="cart-item">
                <!-- 商品圖片 -->
                <div class="item-image">
                  <img :src="item.image" :alt="item.name" />
                </div>

                <!-- 商品詳情 -->
                <div class="item-details">
                  <h4 class="item-name">{{ item.name }}</h4>
                  <p class="item-variant" v-if="item.variantName">
                    規格：{{ item.variantName }}
                  </p>
                  <p class="item-price">
                    單價：NT$ {{ formatPrice(item.price) }}
                  </p>

                  <!-- 數量控制 -->
                  <div class="item-quantity">
                    <button
                      class="quantity-btn"
                      @click="decreaseQuantity(item)"
                      :disabled="item.quantity <= 1"
                    >
                      -
                    </button>
                    <input
                      type="number"
                      class="quantity-input"
                      v-model.number="item.quantity"
                      @change="updateQuantity(item, $event.target.value)"
                      min="1"
                      max="99"
                    />
                    <button
                      class="quantity-btn"
                      @click="increaseQuantity(item)"
                      :disabled="item.quantity >= 99"
                    >
                      +
                    </button>
                  </div>
                </div>

                <!-- 商品總價和刪除按鈕 -->
                <div class="item-total">
                  <span>NT$ {{ formatPrice(item.price * item.quantity) }}</span>
                  <button
                    class="delete-btn"
                    @click="removeItem(item)"
                    title="刪除商品"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右側：訂單摘要 -->
        <div v-if="cartItems.length > 0" class="sidebar">
          <div class="card">
            <h2>訂單摘要</h2>

            <!-- 優惠券區塊 -->
            <div v-if="cartData?.CouponId" class="coupon-applied">
              <div class="coupon-info">
                <i class="fas fa-ticket-alt"></i>
                <span>{{ cartData.CouponName || "已套用優惠券" }}</span>
                <button class="remove-coupon" @click="cancelCoupon">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>

            <!-- 如果沒有優惠券才允許選擇 -->
            <button v-else class="coupon-btn" @click="openCouponDialog">
              <i class="fas fa-tags"></i>
              使用優惠券
            </button>

            <!-- 訂單計算 -->
            <div class="order-summary">
              <div class="summary-row">
                <span>商品小計：</span>
                <span>NT$ {{ formatPrice(totalAmount) }}</span>
              </div>
              <!-- <div class="summary-row">
                <span>運費：</span>
                <span>NT$ {{ formatPrice(shippingFeeAuto) }}</span>
              </div> -->
              <div v-if="selectedCoupon" class="summary-row discount">
                <span>優惠折抵：</span>
                <span
                  >-NT$
                  {{
                    formatPrice(totalAmount + shippingFee - finalAmount)
                  }}</span
                >
              </div>
              <div class="summary-row total">
                <span>總計：</span>
                <span>NT$ {{ formatPrice(finalAmount) }}</span>
              </div>
            </div>

            <!-- 按鈕群組 -->
            <div class="btn-group">
              <button class="btn btn-primary" @click="goToCheckout">
                前往結帳
              </button>
              <button class="btn btn-secondary" @click="clearCart">
                清空購物車
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="@/assets/js/cart"  defer></script>
<style scoped src="@/assets/css/cart.css"></style>
